'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.calendar', {
    url: 'calendar/',
    templateUrl: '/views/partials/clinic/calendar.html',
    controller: 'ClinicCalendarCtrl',
    resolve: {
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Calendar - ' + clinic.name + ' - Opencare');
      },
      hasAppointments: function(clinic, AppointmentService) {
        return AppointmentService.hasAppointments('clinic', clinic.id);
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicCalendarCtrl', function(hasAppointments, $scope) {
  $scope.hasAppointments = hasAppointments;
});
